'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = withQuery;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('@apollo/client/react/components');

var _get = require('./get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = { fetchPolicy: 'cache-and-network' };

function getDisplayName(mapProps) {
  var props = mapProps({});
  return (0, _get2.default)(props, 'query', 'definitions', 0, 'name', 'value');
}

function withQuery(mapProps, mapResultToProps) {
  var displayName = getDisplayName(mapProps);

  return function (WrappedComponent) {
    var component = function component(props) {
      return _react2.default.createElement(
        _components.Query,
        (0, _extends3.default)({ fetchPolicy: config.fetchPolicy }, mapProps(props)),
        function (result) {
          var mappedProps = mapResultToProps(result, props);
          return _react2.default.createElement(WrappedComponent, (0, _extends3.default)({}, props, mappedProps));
        }
      );
    };

    component.displayName = 'withQuery(' + displayName + ')';
    return _react2.default.memo(component);
  };
}

withQuery.setConfig = function (newConfig) {
  config = (0, _extends3.default)({}, config, newConfig);
};